var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyMenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61138 6.87328L0.160979 2.42286C-0.0536598 2.20822 -0.0536598 1.86023 0.160979 1.64562L0.680047 1.12655C0.89432 0.912278 1.24159 0.911865 1.45637 1.12563L5.00001 4.65267L8.54363 1.12563C8.75841 0.911865 9.10568 0.912278 9.31995 1.12655L9.83902 1.64562C10.0537 1.86026 10.0537 2.20824 9.83902 2.42286L5.38864 6.87328C5.174 7.0879 4.82602 7.0879 4.61138 6.87328Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyMenuArrow);
export default __webpack_public_path__ + "static/media/grey_menu_arrow.b55bf9dde7d34d42eda42467de766829.svg";
export { ForwardRef as ReactComponent };